var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M905 4598 c-136 -26 -282 -140 -344 -270 -46 -98 -60 -204 -39 -301 23 -103 60 -177 123 -245 306 -329 845 -117 845 333 0 314 -277 542 -585 483z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3380 3290 c-47 -10 -107 -26 -135 -35 -167 -58 -335 -186 -425 -327 l-40 -60 -2 188 -3 189 -407 3 -408 2 0 -1370 0 -1370 425 0 425 0 0 733 c0 730 5 849 36 972 37 144 125 259 236 310 114 52 297 58 412 15 111 -42 194 -145 230 -286 30 -117 36 -279 36 -1006 l0 -728 425 0 425 0 0 798 c0 825 -6 1007 -41 1202 -82 465 -318 711 -746 775 -135 20 -336 18 -443 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 1880 l0 -1370 425 0 425 0 0 1370 0 1370 -425 0 -425 0 0 -1370z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.0d200a7d7a088b44da8015eff579708e.svg";
export { ForwardRef as ReactComponent };